import Swal from "sweetalert2";

import './popup-message.styles.scss';

const PopupYesNoWithSpecificRedirect = async (icon, title,confirmText,cancelText,extraClass,funct) => {
  await Swal.fire({
    icon: icon,
    title: title,
    allowOutsideClick: false,
    showConfirmButton: true,
    showCancelButton: true,
    showCloseButton: false,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    customClass: extraClass
  }).then((result) => {
    funct(result);
  });
};

export default PopupYesNoWithSpecificRedirect;
